import axios from 'axios';
import { Navigate } from 'react-router-dom';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}`
});

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.headers['X-User-Role'] = sessionStorage.getItem('role');
  config.headers['X-User-Name'] = sessionStorage.getItem('username'); 
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Handle 401 Unauthorized error here
      // Clear session storage and redirect to the login page
      sessionStorage.clear();
      Navigate('/login'); // Replace with your login page URL
    }
    return Promise.reject(error);
  }
);

export default api;
